import React from 'react'
import {
  DevicesFeature,
  OfflineDownloadFeature,
} from '../../../../components/Matrix/features'
import { FreeGiftBanner } from './features/FreeGiftBanner'
import { PlanZPricingFeature } from './features/PlanZPricingFeature'

export const MatrixFeatures = () => (
  <>
    <PlanZPricingFeature />
    <FreeGiftBanner />

    <DevicesFeature />
    <OfflineDownloadFeature />
  </>
)
